import { MissMFCResponse } from '../../../types'
import {
    API_MISS_MFC,
    API_MISS_MFC_HISTORY,
    API_MISS_MFC_MODEL_HISTORY,
} from '../../constants/endpoints'
import { APPSTATE } from '../../state'
import { controller } from '../../utilities/abortController'
import { EdgeApiResponse } from './utilities'

interface MissMFCUser {
    user_id: number
    model_group: number
    rank: number
    prize_volume: number
    record_date: string
    username: string
    vstate: number
    user_font: string
    is_online_now: boolean
    is_anonymous: boolean
}

interface MissMFCMonth {
    self: null
    token: null
    current_rank: null
    month_name: string
    rankings: {
        contest_month: string
        id: string
        last_updated: string
        users: Array<MissMFCUser>
    }
}

export interface MissMFCAnnualRankings extends EdgeApiResponse {
    result: {
        year: string
        months: Record<string, MissMFCMonth>
    }
}

interface Ranking {
    contest_month_formatted: string
    contest_month: string
    rank: number
}

export interface MissMFCModelRankings extends EdgeApiResponse {
    result: {
        rankings: Array<Ranking>
        user_font: string
        username: string
    }
}

export async function getMissMyFreeCams() {
    const response = await fetch(`${API_MISS_MFC}?limit=1000`, {
        credentials: 'include',
        signal: controller.signal,
    })
    return (await response.json()) as MissMFCResponse
}

export async function setMissMFCOptOut(optout: 0 | 1, token?: string | null) {
    const body = new URLSearchParams({
        miss_mfc_optout: String(optout),
        token: token || APPSTATE.session.token || '',
    }).toString()
    const response = await fetch(`${API_MISS_MFC}/changeSettings`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
        signal: controller.signal,
    })
    return (await response.json()) as EdgeApiResponse<Array<string>>
}

export async function getMissMyFreeCamsByYear(year: string) {
    const url = API_MISS_MFC_HISTORY
    const response = await fetch(`${url}/${year}`, {
        signal: controller.signal,
    })
    return (await response.json()) as MissMFCAnnualRankings
}

export async function getMissMyFreeCamsByModelName(modelname: string) {
    const url = API_MISS_MFC_MODEL_HISTORY
    const response = await fetch(`${url}/${modelname}`, {
        signal: controller.signal,
    })
    return (await response.json()) as MissMFCModelRankings
}
